import { render, staticRenderFns } from "./PreAtendimentoEnfermagem.vue?vue&type=template&id=93b959ca&scoped=true&"
import script from "./PreAtendimentoEnfermagem.vue?vue&type=script&lang=js&"
export * from "./PreAtendimentoEnfermagem.vue?vue&type=script&lang=js&"
import style0 from "./PreAtendimentoEnfermagem.vue?vue&type=style&index=0&id=93b959ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b959ca",
  null
  
)

export default component.exports